module.exports = __webpack_public_path__ + "media/src/images/icons/facebook_logo-4e3eec9295d39212445f4238288d8d9b.svg";